import http from "./http";
import qs from 'qs'

export default {
    /**
     * Consulta las solicitudes del usuario monte de piedad.
     */
    all(){
        return http.get(`montepiedad/solicitudes`);
    }

}